import OapSlider from './code/Scripts/components/OapSlider.vue';

export default {
  components: {
    OapSlider,
  },
};
